import * as React from "react";
import { UitkImage } from "uitk-react-images";
import LazyLoad from "react-lazyload";
import { hasQueryParamValue } from "components/utility/FeatureFlag/UrlUtils";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

const WITH_NATIVE_LAZY_LOAD_FLAG = "withNativeLazyLoad";

/**
 * Implements a lazy loaded image with a given alt text.
 * @param props
 * @constructor
 */
export const LazyLoadedImage = (props: {
  src?: string;
  alt?: string;
  offset?: number;
  context?: ExtendedContextStore;
}) => {
  // Enable native lazy loading behind feature flag (withNativeLazyLoad=1)
  if (hasQueryParamValue(WITH_NATIVE_LAZY_LOAD_FLAG, "1", props.context)) {
    return <NativeLazyLoadedImage src={props.src} alt={props.alt} />;
  }

  const placeholderImage = <UitkImage alt={props.alt || ""} placeholderImage={true} />;
  const imageComponent = props.src ? (
    <UitkImage alt={props.alt || ""} src={props.src} placeholderImage={true} />
  ) : (
    placeholderImage
  );

  // Offset makes it so that the component will only be loaded when it's top edge is 250px
  // from the viewport as to make the user ignorant about the lazy load effect
  return (
    <LazyLoad once={true} height="100%" placeholder={placeholderImage} offset={props.offset || 250}>
      {imageComponent}
    </LazyLoad>
  );
};

/**
 * Uses loading=lazy attribute to enable native lazy loading
 * @param props
 * @constructor
 */
const NativeLazyLoadedImage = (props: { src?: string; alt?: string }) => {
  const imageProps = {
    alt: props.alt,
    src: props.src,
    additionalProps: {
      loading: "lazy"
    }
  };

  return <UitkImage {...imageProps} src={props.src} />;
};
